var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxGold = function SvgCheckboxGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#checkbox-gold_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#AD8943",
    rx: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.813 4.914c.234.234.234.586 0 .797l-6.188 6.187a.513.513 0 0 1-.773 0L2.664 8.711c-.234-.211-.234-.563 0-.797.211-.21.563-.21.773 0l2.813 2.813 5.79-5.813c.21-.21.562-.21.773 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checkbox-gold_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    rx: 2.02
  })))));
};
export default SvgCheckboxGold;